// Panier surmonté d'un « + » : lucide-react ne fournit pas cette variante, et
// le panier seul ne dit pas qu'on ajoute — il ressemble au panier du menu.
// Tracé calqué sur la géométrie de lucide (viewBox 24, contour, bouts arrondis)
// pour rester cohérent avec les autres icônes du site.
export default function CartPlusIcon({ className = 'w-4 h-4' }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {/* Roues */}
      <circle cx="9" cy="20" r="1.3" />
      <circle cx="18" cy="20" r="1.3" />
      {/* Anse puis contour du bac */}
      <path d="M2 3h2.2l2.6 12.1a1.8 1.8 0 0 0 1.76 1.4h9.06a1.8 1.8 0 0 0 1.76-1.4L21.2 7.4H5.1" />
      {/* Plus, centré dans le bac */}
      <path d="M13 9.6v3.6" />
      <path d="M11.2 11.4h3.6" />
    </svg>
  );
}
